import { useBillingStore } from '@/store/stores/billing'
import { ensureProjectBillingLoaded } from '@/helpers/channels/ensureProjectBillingLoaded'
import { isBeautyAutopilotEnabled } from '@/helpers/beautyAutopilot'
import { getProjectBillingStatus } from '@/helpers/projectBillingStatus'

/**
 * Статус «только BA» для проверок вне компонентов (роутер): дожидается текущего тарифа, иначе проект
 * с тарифом и BA до загрузки выглядел бы как «только BA».
 */
export async function isBeautyAutopilotOnlyProject(project: any): Promise<boolean> {
    if (!project?.id || !project.billingEnabled || !isBeautyAutopilotEnabled(project)) return false

    await ensureProjectBillingLoaded(project.id, project)
    const billingStore = useBillingStore()
    if (!billingStore.isCurrentTariffFetched(project.id)) return false

    return (
        getProjectBillingStatus({
            billingEnabled: true,
            billingBlock: Boolean(project.billingBlock),
            currentTariff: billingStore.getCurrentTariff(project.id),
            previousTariff: billingStore.getPreviousTariff(project.id),
            isTrialActivatedBefore: billingStore.getIsTrialActivatedBefore(),
            beautyAutopilotEnabled: true,
        }) === 'beautyAutopilotOnly'
    )
}
